<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>تصویر</th>
                    <th>ایندکس آواتار</th>
                    <th>نام آواتار</th>
                    <th>جنسیت</th>
                    <th>وضعیت</th>
                    <th>دیفالت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="avatar in avatars" :key="avatar._id">
                    <td>
                      <img
                        v-if="avatar.imageUrl"
                        :src="avatar.imageUrl"
                        alt=""
                        style="max-height: 40px; max-width: 60px; object-fit: contain;"
                      />
                      <span v-else>-</span>
                    </td>
                    <td>{{ avatar.avatarIndex }}</td>
                    <td>{{ avatar.avatarName }}</td>
                    <td>{{ avatar.isGirl ? 'دخترونه' : 'پسرونه' }}</td>
                    <td>{{ avatar.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ avatar.isDefault ? 'اصلی' : 'فرعی' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/avatar', query: { id: avatar._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import avatarService from '../../../../services/avatar';
export default {
  name: 'avatars',
  data() {
    return {
      avatars: [],
    };
  },
  created() {
    this.getavatars();
  },
  methods: {
    async getavatars() {
      try {
        const condition = {};
        const resData = await avatarService.getAllAvatars(condition);
        console.log(resData);
        this.avatars = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
